import { render } from "./NexusHQBeta.vue?vue&type=template&id=dec07ba8"
const script = {}
script.render = render

export default script